module.exports = __webpack_public_path__ + "static/media/s_v10_t9_2.7e560cd3.mp3";